__turbopack_context__.v({
  "desktopFlag": "Onfana_desktopFlag",
  "desktopFlagForGuest": "Onfana_desktopFlagForGuest",
  "mobileFlag": "Onfana_mobileFlag",
  "statusText": "Onfana_statusText",
  "statusWidget": "Onfana_statusWidget",
});
